import { useEffect } from 'react';
import { X } from 'lucide-react';

interface LightboxProps {
  src: string;
  caption?: string;
  onClose: () => void;
}

export function Lightbox({ src, caption, onClose }: LightboxProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      className="fixed inset-0 z-[100] bg-bgDeep/90 backdrop-blur-sm flex flex-col items-center justify-center p-6"
    >
      <button
        onClick={onClose}
        aria-label="Close"
        className="absolute top-6 right-6 text-white/80 hover:text-white"
      >
        <X size={28} />
      </button>
      <img
        src={src}
        alt={caption ?? ''}
        onClick={(e) => e.stopPropagation()}
        className="max-w-full max-h-[80vh] object-contain rounded-md shadow-lg"
      />
      {caption && (
        <p className="mt-6 font-serif italic text-white/80 text-display-sm text-center max-w-2xl">
          {caption}
        </p>
      )}
    </div>
  );
}
